import {
  ViewActivityEngagementRequest,
  ViewHashtagEngagementRequest,
  ViewHashtagOccurencesRequest
} from './administration.types';

import { API_HOST, HttpGetOptions, getHttpGetOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/administration`;

export const getViewActivityEngagementRequest = (data: ViewActivityEngagementRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/activity/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewHashtagEngagementRequest = (data: ViewHashtagEngagementRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/hashtag/${data.programmeExternalReference}`,
  getHttpGetOptions()
];

export const getViewHashtagOccurencesRequest = (data: ViewHashtagOccurencesRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/hashtag/occurrence/${data.programmeExternalReference}`,
  getHttpGetOptions()
];
